import React from 'react';

import styles from '../explorer.module.scss';

type Props = { children: React.ReactNode; fallback?: React.ReactNode };
type State = { hasError: boolean; error: Error | null };

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError( error: Error ): State {
    return { hasError: true, error };
  }

  render() {
    if ( this.state.hasError ) {
      return this.props.fallback || (
        <div className={ styles.errorBoundary }>
          <p>Something went wrong rendering this panel.</p>
          <p className={ styles.errorBoundary__detail }>{ this.state.error?.message }</p>
          <button
            data-testid="error-retry-btn"
            onClick={ () => this.setState( { hasError: false, error: null } ) }
            className={ styles.errorBoundary__retryBtn }
          >
            Try Again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
